import '../../components.theme/wysiwyg-accordion/wysiwyg-accordion';
import './wysiwyg-accordion.scss';
